import React from "react";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import { useState, useEffect } from "react";
import { API_URL } from "../../../../constants";
import { GetServiceCaller } from "../../../../services/serviceCaller";
import NewDynamic_PR_table from "../../../../components/NewDynamic_PR_Table";
import { useNavigate } from "react-router-dom";
import Dynamic_PR_table from "../../../../components/Dynamic_PR_table";

const PerformanceEvaluationReport = () => {
  const navigate = useNavigate();

  const [reportList, setReplortList] = useState([]);
  const [appraisalCycle, setAppraisalCycle] = useState([]);

  const [template, setTemplate] = useState([]);
  const [employee, setEmployee] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const [respStatus, setRepStatus] = useState(0);

  // const data = filterFormData.find((o) => o.label === "Appraisal Cycle").valueappraisalCycle[0] || "";

  const [filterFormData, setFilterData] = useState([
    { label: "Appraisal Cycle", value: "" },
    { label: "Template", value: "" },
    { label: "Employee", value: "" },
  ]);


  const [apiStatus, setApiStatus] = useState("")

  const fetchReportList = async () => {
    setApiStatus(undefined)
    try {
      const response = await GetServiceCaller(
        `${API_URL}pr-report/3?P_AppraisalCycleID=0&P_AppraisalTemplateMasterID=0&P_EmployeeID=0`
      );

      setApiStatus(response?.status)

      if (response?.status == 200) {
        setReplortList(response?.data?.header);
        const cycleOpts = response?.data?.appraisalCycle?.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        cycleOpts.unshift({ value: 0, label: "Select..." });
        setAppraisalCycle(cycleOpts);
        if (cycleOpts?.length > 0) {
          setFilterData((prev) => [
            { label: "Appraisal Cycle", value: cycleOpts[0].value },
            ...prev.slice(1),
          ]);
        }
        setFilterData((prevState) =>
          prevState.map((item) =>
            item.label === "Appraisal Cycle"
              ? { ...item, value: cycleOpts[0].label }
              : item
          ));
        const TempletOpts = response?.data?.templateList?.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        TempletOpts.unshift({ value: 0, label: "Select..." });
        setTemplate(TempletOpts);
        const EmployeeOpts = response?.data?.employeeList?.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        EmployeeOpts.unshift({ value: 0, label: "Select..." });
        setEmployee(EmployeeOpts);
        setRepStatus(response.status);
      }
    } catch (error) {
      console.error("Error fetching reports", error);
    }
  };

  useEffect(() => {
    fetchReportList();
  }, []);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Performance Evaluation Report"))
  }, [])

  const columns = {
    AppraisalCycle: { text: "Appraisal Cycle", visible: true },
    Template: { text: "Template", visible: true },
    Employee: { text: "Employee", visible: true },
    Reviewer: { text: "Reviewer", visible: true },
    EvaluationDate: {
      text: "Evaluation Date",
      align: "center",
      format: "date",
      visible: true
    },
    EmployeeRating: { text: "Employee Rating", align: "center", visible: true },
    ReviewDate: { text: "Review Date", align: "center", format: "date", visible: true },
    ReviewerRating: { text: "Reviewer Rating", align: "center", visible: true },
  };
  const defaultColumns = {
    AppraisalCycle: true,
    Template: true,
    Employee: true,
    Reviewer: true,
    EvaluationDate: true,
    EmployeeRating: true,
    ReviewDate: true,
    ReviewerRating: true,
  };

  const formDatas = [
    {
      name: "Appraisal Cycle",
      type: "Select",
      options: [...appraisalCycle],
    },
    {
      name: "Template",
      type: "Select",
      options: [...template],
    },
    {
      name: "Employee",
      type: "Select",
      options: [...employee],
    },
  ];

  const handleGetData = async () => {
    setApiStatus(undefined)
    try {
      const response = await GetServiceCaller(
        `${API_URL}pr-report/3?P_AppraisalCycleID=${filterFormData.find((o) => o.label === "Appraisal Cycle")
          ? filterFormData.find((o) => o.label === "Appraisal Cycle").value
          : 0
        }&P_AppraisalTemplateMasterID=${filterFormData.find((o) => o.label === "Template")
          ? filterFormData.find((o) => o.label === "Template").value
          : 0
        }&P_EmployeeID=${filterFormData.find((o) => o.label === "Employee")
          ? filterFormData.find((o) => o.label === "Employee").value
          : 0
        }`
      );


      setApiStatus(response?.status)
      if (response.status === 200) {
        const cleanedData = response.data.header;        
        setReplortList(cleanedData);
        setLoading(false);
      } else {
        console.error(
          "Failed to fetch partnerMaster. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching PartnerMaster:", error);
    }
  };

  const handleChange = (e, name) => {
    setFilterData((prevFormData) => {
      // Check if the label already exists
      const existingLabelIndex = prevFormData.findIndex(
        (item) => item.label === name
      );

      // If the label exists, update its value
      if (existingLabelIndex !== -1) {
        const updatedFormData = prevFormData.map((item, index) =>
          index === existingLabelIndex
            ? { ...item, value: e.value !== undefined ? e.value : e }
            : item
        );
        return updatedFormData;
      } else {
        // If the label doesn't exist, add a new label-value pair
        return [
          ...prevFormData,
          {
            label: name,
            value: e.value !== undefined ? e.value : e, // Assuming e is an event object
          },
        ];
      }
    });
  };

  const handleView = (id) => {
    navigate(`/pr-evaluation-report/${id.ID}`)
  };

  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid " id="skill-table-area">
          <div className="box-body table-responsive container-fluid ">
            <div className="row mt-2">
              <Dynamic_PR_table
                data={reportList}
                columns={columns}
                itemsPerPage={8}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                showIcon1={false}
                showIcon2={false}
                showIcon3={true}
                isRequiredStatus={true}
                isApiStatus={apiStatus}
                showIcon4={false}
                showIcon5={false}
                formDatas={formDatas}
                responseStatus={respStatus}
                filterFormData={filterFormData}
                handleGetData={handleGetData}
                isActionRequired={true}
                isFilterRequired={true}
                isCheckBoxRequired={false}
                // handleIcon1={handleEdit}
                handleIcon3={handleView}
                // handleIcon4={handleOpen}
                handleChange={handleChange}
                add
                more
                function
                icons={{
                  Icon1: <i class="bi bi-pencil-square  icons"></i>,
                  Icon2: <i class="bi bi-trash-fill icons"></i>,
                  Icon3: <i class="bi bi-eye-fill icons"></i>,
                  Icon4: <i class="bi bi-person-plus icons"></i>,
                  Icon4Text: "Create Employee",
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PerformanceEvaluationReport;
